import img1 from '../Assets/images/bora_bora.jpg'
import img2 from '../Assets/images/machu_picchu.jpg'
import img3 from '../Assets/images/great_barrier_reef.jpg'
import img4 from '../Assets/images/cappadocia.jpg'
import img5 from '../Assets/images/guanajuato.jpg'
import img6 from '../Assets/images/cinque _terre.jpg'
import img7 from '../Assets/images/ankor_wat.jpg'
import img8 from '../Assets/images/taj_mahal.jpg'
import img9 from '../Assets/images/bali_island.jpg'


export const destinations = [
    {
        id:1,
        image: img1,
        destTitle:"Bora Bora",
        location:"New Zealand",
        grade:"CULTURAL RELAX",
        fees: "$700",
        description:"The epitome of romance, Bora Bora is one of the best travel destinations in the World. This place is known for its luxurious stays and adventurous activities."
    },
    {
        id:2,
        image: img2,
        destTitle:"Machu Picchu",
        location:"Peru",
        grade:"CULTURAL RELAX",
        fees: "$600",
        description:"Huayna Picchu is a mountain in Peru, rising over machu Picchu, the so-called Lost City of Incas. This place is popular among tourists as the sunrise from the Sun Gate is simply spectacular."
    },
    {
        id:3,
        image: img3,
        destTitle:"Great Barrier Reef",
        location:"Australia",
        grade:"CULTURAL RELAX",
        fees: "$700",
        description:"One of the most remarkable Australian natural gifts is the Great Barrier Reef. The hallmark of this place is 'lavish' and 'beauty'. always interesting to be in this place."
    },
    {
        id:4,
        image: img4,
        destTitle:"Cappadocia",
        location:"Turkey",
        grade:"CULTURAL RELAX",
        fees: "$800",
        description:"According to the World Tourism Ranking, 45 Million people visit Turkey each year, and from that about 2 Million come to visit Cappadocia. this place is known for its luxurious stays and adventurous activities."
    },
    {
        id:5,
        image: img5,
        destTitle:"Guanajuato",
        location:"Mexico",
        grade:"CULTURAL RELAX",
        fees: "$1100",
        description:"A city in central Mexico, Guanajuato is known for its history of silver mining and colonial architecture. The houses in the city are very attractively painted with the most bright colors available. Always welcome."
    },
    {
        id:6,
        image: img6,
        destTitle:"Cinque Terre",
        location:"Italy",
        grade:"CULTURAL RELAX",
        fees: "$840",
        description:"The vibrant hues of the houses are its benchmark and explain the beauty of this palce. also, if you are a foodie and love seafood, you will be exhilarated with the choice you are about to get here. Happy exploring great food!"
    },
    {
        id:7,
        image: img7,
        destTitle:"Ankor Wat",
        location:"Cambodia",
        grade:"CULTURAL RELAX",
        fees: "$790",
        description:"Angkor Wat represents the entire range of Khmer art from the 9th to the 15th century. This temple is considered as the haert and soul of cambodia. This palce is known for its luxurious stays and adventurous activities."
    },
    {
        id:8,
        image: img8,
        destTitle:"Taj Mahal",
        location:"India",
        grade:"CULTURAL RELAX",
        fees: "$900",
        description:"An immense mausoleum of white marble, built-in Agra by Mughal emperor Shah Jahan in memory oof his wife Mumtaz, the moment is breathtakingly beautiful. This place is known for its luxurious stays and adventurous activities."
    },
    {
        id:9,
        image: img9,
        destTitle:"Bali Island",
        location:"Indonesia",
        grade:"CULTURAL RELAX",
        fees: "$500",
        description:"Bali is an Indonesian island and one of the best holiday destinations in the indonesian archipelage. Bali is known for its volcanic mountains, history, art & culture, food, temples and beautiful sandy beaches."
    }
]

